import {
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import QuotationService from '../../../../../../../../shared/services/quotation';

import {
  GenericDataFormContext,
  QuotationInfoContext,
  StepOneFormContext,
} from '../../../../shared/contexts';
import { WizardDataFormContext } from './WizardDataFormContext';

import {
  GenerateAPQuotationServiceRequest,
  SelectOption,
} from '../../../../../../../../shared/interfaces';

export interface WizardDataFormState {}

export const WizardDataFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const [quotationForm, setQuotationForm] =
    useState<GenerateAPQuotationServiceRequest>();

  const { clientSelected } = useContext(StepOneFormContext);
  const {
    paymentMethods,
    setIsLoadingPaymentMethods,
    setPaymentMethods,
    setPaymentMethodsList,
  } = useContext(GenericDataFormContext);
  const { quotationInfo } = useContext(QuotationInfoContext);

  const getPaymentMethodPerValidity = useCallback(
    async (article: string, validityFrom: string, validityTo: string) => {
      if (paymentMethods.length) return;

      try {
        setIsLoadingPaymentMethods(true);
        const response = await QuotationService.getPaymentPlans(
          article,
          validityFrom,
          validityTo
        );

        if (response.data?.formasDePago?.length) {
          const paymentMethods: Array<SelectOption> =
            response.data.formasDePago.map(
              ({ descripcion, nroPlanDePago, codigoFormaDePago}) => ({
                label: descripcion,
                value: `${codigoFormaDePago}-${nroPlanDePago}`,
              })
            );
          setPaymentMethodsList(response.data.formasDePago);
          setPaymentMethods(paymentMethods);
        }
      } catch (error) {
      } finally {
        setIsLoadingPaymentMethods(false);
      }
    },
    [setPaymentMethods, setPaymentMethodsList]
  );

  useEffect(() => {
    if (clientSelected) {
      setQuotationForm({
        ...quotationForm!,
        cliente: clientSelected,
      });
    }
  }, [clientSelected]);

  useEffect(() => {
    if (quotationInfo) {
      setQuotationForm({
        token: quotationInfo.token,
        rama: quotationInfo.branch,
        articuloRamaSecuencia: quotationInfo.arse,
      });
    }
  }, [quotationInfo]);

  useEffect(() => {
    if (
      quotationInfo?.article &&
      quotationForm?.vigenciaDesde &&
      quotationForm?.vigenciaHasta
    ) {
      getPaymentMethodPerValidity(
        quotationInfo?.article,
        quotationForm.vigenciaDesde,
        quotationForm.vigenciaHasta
      );
    }
  }, [quotationInfo, quotationForm, getPaymentMethodPerValidity]);

  const values = useMemo(
    () => ({
      quotationForm,
      setQuotationForm,
    }),
    [quotationForm, setQuotationForm]
  );

  return (
    <WizardDataFormContext.Provider value={values}>
      {children}
    </WizardDataFormContext.Provider>
  );
};
